import axios from 'axios';
import { useMutation } from '@tanstack/react-query';

import { TypeMaster } from 'models/type/TypeMaster';

export function useAddWorkflowTypeMaster() {
    return useMutation({
        mutationFn: (request: TypeMaster) => {
            const accessToken = localStorage.getItem('WF_APPLICATION');

            return axios.post('/v2/configuration/workflow/type', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        }
    });
}
